import { DateTime } from "../../utils/luxon.js";
import type { Competition } from "../Competition.js";
import { CompetitionCategoryType } from "../CompetitionCategoryType.js";

export function getMaximumBirthdateOfDog(
	competition: Pick<Competition, "competitionStart">,
	competitionCategoryTypes: CompetitionCategoryType[],
): DateTime {
	const nowDate = DateTime.fromISO(competition.competitionStart);
	let minBirthDate = nowDate.minus({ month: 12 });
	if (
		competitionCategoryTypes.some(
			(category) => ![CompetitionCategoryType.Sptf1, CompetitionCategoryType.Sptf2].includes(category),
		)
	) {
		minBirthDate = nowDate.minus({ month: 18 });
	}
	return minBirthDate;
}
